module.exports = __webpack_public_path__ + "img/summary_white.368b7e13.svg";